// Same imperative toast the public client uses, restyled to the admin palette.
// Kept dependency-free so it can be called from react-query callbacks that
// have no component context.
const showToast = (message, status = "success") => {
  const toast = document.createElement("div");
  toast.setAttribute("role", status === "success" ? "status" : "alert");
  toast.textContent = message;
  toast.className = [
    "fixed bottom-6 right-6 z-50 max-w-sm px-4 py-3 rounded shadow-lg",
    "font-sans text-sm text-white transition-opacity duration-300",
    status === "success" ? "bg-ink" : "bg-danger",
  ].join(" ");

  document.body.appendChild(toast);

  setTimeout(() => {
    toast.style.opacity = 0;
    setTimeout(() => toast.remove(), 300);
  }, 3500);
};

export default showToast;
